import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * The old "My consultations" page (/consultations) is part of Home now. Links to it from
 * imavenai.com and the advice-ready email (/consultations?email=…) keep working: they land on Home
 * with the query kept, and Home opens the "find consultations" box for that email.
 */
const ConsultationsRedirect = () => {
  const location = useLocation();
  return <Navigate to={{ pathname: '/', search: location.search }} replace />;
};

export default ConsultationsRedirect;
